import { css } from 'lit';
export const fusionSwapInfoStyle = css `
  :host {
    display: flex;
    flex-direction: column;
  }
`;
//# sourceMappingURL=fusion-swap-info.style.js.map